<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <slot />
        <!-- <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_placeholder_search') ||
                  '产品SKU编号/SKU名称/SKU品牌/NC物料编码/工厂/店铺/市场/市场/售卖标题/亚马逊SKU/ASIN/FNSKU/店铺品牌/运营人员 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <el-checkbox
              v-model="searchFocus"
              size="small"
              class="ml-2 checkbox-focus"
              border
              @change="query"
            >
              {{ $l('btn_searchFocus') || '仅查看重点关注' }}
            </el-checkbox>
          </b-input-group>
        </b-form> -->
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      top="10vh"
      width="900px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_operate') || '运营人员'">
              <dict-select
                v-model="form.listOperateCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_operate') || '请选择运营人员'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_amzStore') || '店铺'">
              <dict-select
                v-model="form.listAmzStoreCode"
                url="/ecom/amz/store/select"
                :placeholder="$l('form_placeholder_amzStore') || '请选择店铺'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_region') || '市场'">
              <dict-select
                v-model="form.listRegionCode"
                :body="{ dictType: 'region' }"
                url="/master/common/dict/biz"
                :options="{ label: 'value', value: 'value' }"
                :placeholder="$l('form_placeholder_region') || '请选择市场'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_amzSkuNo') || '亚马逊SKU'">
              <el-input
                v-model.trim="form.amzSkuNo"
                :placeholder="
                  $l('form_placeholder_amzSkuNo') || '请输入亚马逊SKU'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_asinCode') || 'ASIN'">
              <el-input
                v-model.trim="form.asinCode"
                :placeholder="$l('form_placeholder_asinCode') || '请输入ASIN'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_fnskuCode') || 'FNSKU'">
              <el-input
                v-model.trim="form.fnskuCode"
                :placeholder="$l('form_placeholder_fnskuCode') || '请输入FNSKU'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_amzGoodsSkuNo') || '产品SKU编号'"
            >
              <el-input
                v-model.trim="form.amzGoodsSkuNo"
                :placeholder="
                  $l('form_placeholder_amzGoodsSkuNo') || '请输入产品SKU编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_goodsName') || 'SKU名称'">
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="
                  $l('form_placeholder_goodsName') || '请输入SKU名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_brand') || 'SKU品牌'">
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('form_placeholder_brand') || '请选择SKU品牌'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$l('form_label_ncNo') || 'NC物料编码'">
              <el-input
                v-model.trim="form.ncNo"
                :placeholder="$l('form_placeholder_ncNo') || '请输入NC物料编码'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_scm') || '工厂'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('form_placeholder_scm') || '请选择工厂'"
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$l('form_label_storeBrand') || '店铺品牌'">
              <dict-select
                v-model="form.listStoreBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="
                  $l('form_placeholder_storeBrand') || '请选择店铺品牌'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$l('form_label_sellType') || '售卖方式'">
              <el-select
                v-model="form.listSellType"
                :placeholder="
                  $l('form_placeholder_sellType') || '请选择售卖方式'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              >
                <el-option
                  :label="$l('form_label_sellType_a') || '正常上架'"
                  value="A"
                ></el-option>
                <el-option
                  :label="$l('form_label_sellType_b') || '跟卖'"
                  value="B"
                ></el-option>
                <el-option
                  :label="$l('form_label_sellType_c') || '跨站点售卖'"
                  value="C"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_storeSkuStatus') || '售卖状态'"
            >
              <dict-select
                v-model="form.listStoreSkuStatus"
                :body="{ dictType: 'amzStoreSkuStatus' }"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('form_placeholder_storeSkuStatus') || '请选择售卖状态'
                "
                filterable
                clearable
                multiple
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item :label="$l('form_label_salesPrice') || '售卖价格'">
                <br />
                <el-col :span="8">
                  <el-input-number
                    v-model="form.salesPriceStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    size="mini"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.salesPriceEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    size="mini"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.salesCurrencyUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'currencyUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    filterable
                    clearable
                    size="mini"
                    style="width:100%"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_salesTitle') || '售卖标题'">
              <el-input
                v-model.trim="form.salesTitle"
                :placeholder="
                  $l('form_placeholder_salesTitle') || '请输入售卖标题'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      searchFocus: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const isFocus = this.searchFocus ? 'Y' : null
      this.$emit('query', { ...this.form, isFocus })
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
// ::v-deep {
//   .checkbox-focus {
//     // --color: #409eff;
//     --color: #e6a23c;
//     &.el-checkbox.is-bordered.is-checked {
//       border-color: var(--color);
//     }
//     .el-checkbox__input.is-checked .el-checkbox__inner,
//     .el-checkbox__input.is-indeterminate .el-checkbox__inner {
//       background-color: var(--color);
//       border-color: var(--color);
//     }
//     .el-checkbox__input.is-checked + .el-checkbox__label {
//       color: var(--color);
//     }
//     .el-checkbox__inner:hover {
//       border-color: var(--color);
//     }
//   }
// }
</style>
